import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@workos-inc/authkit-react';

const Callback = () => {
  const { user, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // When the user is authenticated, redirect them to the home page
    if (!isLoading && user) {
      // Use replace to avoid the callback URL in the browser history
      navigate('/home', { replace: true });
    }
    // If there's an error or no user, you could redirect to a login/error page
    // For now, the ProtectedRoute will handle the unauthenticated case
  }, [isLoading, user, navigate]);

  // Render a loading state while authentication is in progress
  return <h4>Authenticating...</h4>;
};

export default Callback;
